import { render, staticRenderFns } from "./EditEmployeeModal.vue?vue&type=template&id=01ece684&scoped=true&lang=pug"
import script from "./EditEmployeeModal.vue?vue&type=script&lang=js"
export * from "./EditEmployeeModal.vue?vue&type=script&lang=js"
import style0 from "./EditEmployeeModal.vue?vue&type=style&index=0&id=01ece684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ece684",
  null
  
)

export default component.exports